import { useRequest } from 'ahooks';
import axios from 'axios';
import { t } from 'i18next';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { environment } from 'src/environment';
import { Filter, IFilter, getFilterModelByName } from '../filterModels';
import { getFilterValueByName } from '../FiltersSlice';
import SingleSelector from '../SingleSelector';

type Props = IFilter & {
  filterName: Filter;
};

export const ALL = Symbol('ALL').toString();
const ActivityCodeFilter = (props: Props) => {
  const [showFilter, setShowFilter] = useState<Boolean>(false);
  const filter = getFilterModelByName(props.filterName);
  const dateRangeFilter = useSelector(getFilterValueByName('DateRangeFilter'));
  const { data, run } = useRequest(
    (data) => {
      return axios.post(`${environment.reportingEndpoint}/api/filter/feetaskcodes`, {
        dateRange: data,
      });
    },
    {
      manual: true,
      ready: dateRangeFilter?.data && dateRangeFilter.isValid,
      debounceTrailing: true,
      debounceWait: 500,
    },
  );

  useEffect(() => {
    if (dateRangeFilter?.isValid && dateRangeFilter?.data) {
      run(dateRangeFilter?.data);
    }
  }, [dateRangeFilter, run]);

  useEffect(() => {
    if (dateRangeFilter?.data) {
      // const fetchFilterDataAPI = `${environment.reportingEndpoint}/api/feetaskcodes/${dateRangeFilter?.data?.From}/${dateRangeFilter?.data?.To}`;
      // updateCurrentFilterModel(props.filterName, {});
      setShowFilter(true);
    } else {
      setShowFilter(false);
    }
  }, [dateRangeFilter?.data, props.filterName]);

  const newModel: IFilter = useMemo(() => {
    const defaultTransform = (value: { TaskCodeId: string; TaskCode: string }) => {
      return {
        label: value.TaskCode,
        value: value.TaskCodeId,
      };
    };
    const dropDownOptionTransform = filter?.dropDownOptionTransform || defaultTransform;
    const staticDropDownOptionsList = data?.data?.map(dropDownOptionTransform) || [];
    staticDropDownOptionsList.unshift({
      label: t('All'),
      value: ALL,
    });

    return {
      ...filter,
      config: {
        isStatic: true,
      },
      staticDropDownOptionsList: staticDropDownOptionsList,
    };
  }, [data, filter]);
  return showFilter ? (
    <SingleSelector
      key={`${dateRangeFilter?.data?.From}_${dateRangeFilter?.data?.To}`}
      passedInFilterModel={newModel}
      {...props}
    />
  ) : null;
};
export default ActivityCodeFilter;
